import {
  yesNoSchema,
  yesNoUI,
  textUI,
  titleUI,
  currentOrPastDateUI,
  currentOrPastDateSchema,
} from 'platform/forms-system/src/js/web-component-patterns';
import content from '../../../../utils/content.json';
import { isYes } from '../../../../utils/helpers';
import { customTextSchema } from '../../../../config/definitions';
import { CourtOrderSeparationAlert } from '../../../../components/FormAlerts';
import { validations } from '../../../../config/validations';

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(content['household-separation-details-title']),
    separationExplanation: textUI({
      title: content['household-separation-details-explanation'],
      errorMessages: {
        required: content['household-separation-details-explanation-error'],
      },
      hideIf: formData => formData?.separationDueToAssignedReasons !== 'OTHER',
      required: formData =>
        formData?.separationDueToAssignedReasons === 'OTHER',
    }),
    separationStartDate: currentOrPastDateUI({
      title: content['household-separation-details-start-date'],
    }),
    separationEndDate: currentOrPastDateUI({
      title: content['household-separation-details-end-date'],
      validations: [validations.isAfterSeparationStartDate],
    }),
    courtOrderedSeparation: yesNoUI({
      title: content['household-separation-details-court-ordered'],
    }),
    courtOrderAlert: {
      'ui:description': CourtOrderSeparationAlert,
      'ui:options': {
        hideIf: formData => !isYes(formData?.courtOrderedSeparation),
        displayEmptyObjectOnReview: true,
      },
    },
  },
  schema: {
    type: 'object',
    required: ['separationStartDate', 'courtOrderedSeparation'],
    properties: {
      separationExplanation: customTextSchema,
      separationStartDate: currentOrPastDateSchema,
      separationEndDate: currentOrPastDateSchema,
      courtOrderedSeparation: yesNoSchema,
      courtOrderAlert: {
        type: 'object',
        properties: {},
      },
    },
  },
};
